<template>


</template>

<script>
export default {
  name: "YourSolutionTabComponent",
  data() {
    return {

    }

  },
  methods: {
    playHistory() {
      if (this.isPlaying) {
        return this.stopHistory();
      }

      let versionIndex = parseInt(this.versionIndex);
      if (versionIndex === this.versions.length - 1) {
        this.versionIndex = 0;
      }

      let play = function () {
        if (!this.isPlaying) {
          return;
        }
        let versionIndex = parseInt(this.versionIndex) + this.step;
        if (versionIndex >= this.versions.length) {
          this.isPlaying = false;
          return;
        }
        this.versionIndex = versionIndex;
        setTimeout(play.bind(this), this.speed);
      };
      this.isPlaying = true;
      setTimeout(play.bind(this), this.speed);
    },
    stopHistory() {
      this.isPlaying = false;
    },
    forwardHistory() {
      this.versionIndex = this.versions.length - 1;
    },
    backwardHistory() {
      this.versionIndex = 0;
    },
    increaseSpeed() {
      let speed = Math.floor(this.speed / 2);
      if (speed < 25) {
        return;
      }
      this.speed = speed;
    },
    decreaseSpeed() {
      let speed = Math.floor(this.speed * 2);
      if (speed >= 1000) {
        return;
      }
      this.speed = speed;
    },
  },

}
</script>

<style scoped>

</style>